var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.templateArgs.data.icone)?_c('img',{staticClass:"img",attrs:{"src":_vm.templateArgs.data.icone || _vm.imgDefault}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }